import config from 'config'
import { getJsonHeaders } from '../helpers'

export async function list(limit = 15, page = 1) {
  try {
    const result = await fetch(
      config.API_URL + `/api/products/system?per_page=${limit}&page=${page}`
    )
    return await result.json()
  } catch (e) {
    return false
  }
}

export async function get(id) {
  try {
    const result = await fetch(config.API_URL + `/api/products/system/${id}`)
    return await result.json()
  } catch (e) {
    return false
  }
}

export async function update(id, body) {
  try {
    const res = await fetch(config.API_URL + `/api/products/system/${id}`, {
      method: 'PUT',
      headers: await getJsonHeaders(),
      body: JSON.stringify(body),
    })

    if (res.status === 200) {
      return {
        success: true,
        message: 'Successfully updated product',
      }
    }

    const decoded = await res.json()
    return {
      success: false,
      message: decoded.message,
      errors: Object.entries(decoded.errors).map(error => {
        return error
      }),
    }
  } catch (e) {
    return {
      success: false,
      message: 'Failed to update product',
      errors: [['', 'Failed to update product']],
    }
  }
}

export async function setFavourite(id, value) {
  const res = await fetch(
    config.API_URL + `/api/products/set-favourite/${id}?v=${value ? 1 : 0}`,
    {
      method: 'PUT',
      headers: await getJsonHeaders(),
    }
  )

  return await res.json()
}
